import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophy02Small = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 1a1 1 0 011-1h14a1 1 0 011 1v1h2a2 2 0 012 2v4a5 5 0 01-5 5h-1.186a10.986 10.986 0 01-4.6 3.579l-.214.089v1.851l4.625 3.7A1 1 0 0117 24H7a1 1 0 01-.625-1.78L11 18.52v-1.852l-.214-.089A10.986 10.986 0 016.186 13H5a5 5 0 01-5-5V4a2 2 0 012-2h2zm16 5.418c0 1.615-.353 3.172-1 4.582a3 3 0 003-3V4h-2zM4 4H2v4a3 3 0 003 3c-.647-1.41-1-2.967-1-4.582zm8.125 1.75h.249a.864.864 0 01.441 1.606l-2.652 1.58A2.38 2.38 0 009 10.98V12h6v-2h-3.204l1.915-1.14A2.614 2.614 0 0012.374 4h-.249a3 3 0 00-3 3h1.75c0-.69.56-1.25 1.25-1.25z"
        fill=""
      />
    </svg>
  )
);
SvgAchievementsTrophy02Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophy02Small;
